import { Component, OnInit, Input } from '@angular/core';
import { Course } from '../../model/distributor.model';
import { AdaService } from '../../../shared/services/ada.service';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss']
})
export class TrainingComponent implements OnInit {

  @Input() training: Array<Course> = [];
  @Input() isEmployee = false;
  @Input() isDealer = false;

  constructor(private _adaService: AdaService) { }

  ngOnInit() {
  }

  get adaService() {
    return this._adaService;
  }


}



// WEBPACK FOOTER //
// ./src/app/distributor/components/training/training.component.ts